import API from 'services/API/index';

export default function getFeedbackQuestions() {
  return API.request({
    method: 'GET',
    url: '/notification/feedback/questions',
  });
}
